import { ProgressBar } from './ProgressBar'
import { useEditMode } from 'directFlow/utils'
import { Header as BaseHeader } from 'components/Header'

export const Header = () => {
  const isEditMode = useEditMode()

  return (
    <BaseHeader
      isEditMode={!!isEditMode}
      progressBar={!isEditMode ? <ProgressBar /> : undefined}
      directFlowHeader
    />
  )
}
